import React, { useState, useEffect } from 'react';
import { dico_privileges } from '../../../ressources/functionJS/translationService';
import Checkbox from './Checkbox/Checkbox';

const ListePrivilegesDetaillees = ({
  defaultChecked,
  remontePrivilegePersonnalise,
}) => {
  const [dynamicDefaultCheckboxValues, setDynamicDefaultCheckboxValues] =
    useState(defaultChecked?.length > 0 ? defaultChecked : []);

  // Init only, on mount: avoid re-syncing on every parent re-render, which would
  // otherwise revert the user's checkbox clicks back to defaultChecked.
  useEffect(() => {
    if (defaultChecked?.length > 0) {
      remontePrivilegePersonnalise(defaultChecked);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChangeDefaultCheckboxValueHandler = (privilegeSelection) => {
    const newValues = [...dynamicDefaultCheckboxValues];
    const intPrivilege = parseInt(privilegeSelection);
    const index = newValues.indexOf(intPrivilege);

    if (index > -1) {
      newValues.splice(index, 1);
    } else {
      newValues.push(intPrivilege);
    }

    setDynamicDefaultCheckboxValues(newValues);
    remontePrivilegePersonnalise(newValues);
  };
  const radioChoice = Object.keys(dico_privileges).map((clePrivilege) => {
    const currentLangueSite = localStorage.getItem('langueSite') || 'fr';
    return (
      <Checkbox
        key={clePrivilege}
        name={dico_privileges[clePrivilege][currentLangueSite]}
        selectRadio={() => onChangeDefaultCheckboxValueHandler(clePrivilege)}
        checked={
          dynamicDefaultCheckboxValues.indexOf(parseInt(clePrivilege)) > -1
        }
      >
        {`${clePrivilege}: ${dico_privileges[clePrivilege][currentLangueSite]}`}
      </Checkbox>
    );
  });

  return <>{radioChoice}</>;
};

export default ListePrivilegesDetaillees;
